import { gql } from '@apollo/client';

export const GET_BALANCE = gql`
    query GetPortalBalance {
        portalBalance {
            customerName
            balance
            currency
            updatedAt
        }
    }
`;
